import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import styles from "./chart.module.scss";

interface ChartProps {
  option: any;
  onChartReady?: (chart: any | null) => void;
}

const Chart: React.FC<ChartProps> = ({ option, onChartReady }) => {
  const chartRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const chartInstance = echarts.init(chartRef.current!);
    chartInstance.setOption(option);
    onChartReady?.(chartInstance);

    return () => {
      onChartReady?.(null);
      chartInstance.dispose(); // 清理资源
    };
  }, [option, onChartReady]);

  return <div ref={chartRef} className={styles.chart}></div>;
};

export default Chart;
